export const NAV_PREFERENCE_KEYS = {
  sidebarCollapsed: "agm.nav.sidebarCollapsed",
  activeDomain: "agm.nav.activeDomain",
};

export const QUICK_ACTION_CONFIG = [
  { key: "cutting-issue", path: "/cutting-issue", label: "Cutting Issue", mobileLabel: "Issue", tone: "amber" },
  { key: "production-receive", path: "/production-receive", label: "Production Receive", mobileLabel: "Prod", tone: "emerald" },
  { key: "urgent-entry", path: "/urgent-entry", label: "Urgent Operator", mobileLabel: "Urg", tone: "red" },
];

export const MOBILE_PRIMARY_NAV = [
  { id: "home", label: "Home", path: "/dashboard" },
  { id: "erp", label: "ERP", launcher: "erp" },
  { id: "scan", label: "Scan", launcher: "scan" },
  { id: "control-tower", label: "Control Tower", path: "/control-tower" },
  { id: "more", label: "More", launcher: "more" },
];

const MOBILE_MODES = new Set(["MOBILE_FULL", "MOBILE_OPERATIONAL", "MOBILE_VIEW_ONLY"]);

export function getMobileLauncherPages(pages, domain, canAccess = () => true) {
  return (pages || []).filter((page) =>
    page.domain === domain && MOBILE_MODES.has(page.mobileMode) && canAccess(page)
  );
}

export function getScanLauncherPages(pages, canAccess = () => true) {
  const scanKeys = new Set(["return-scan", "picklist-list", "bulk-putaway"]);
  return (pages || []).filter((page) =>
    scanKeys.has(page.key) && MOBILE_MODES.has(page.mobileMode) && canAccess(page)
  );
}

export function shouldShowDesktopOnlyNotice(page, isMobileViewport) {
  return Boolean(isMobileViewport && page?.mobileMode === "DESKTOP_ONLY");
}

// A menu shortcut (OMS sections) is checked against the permission key of the page it opens.
export const canAccessPage = (item, { user, hasRole, hasPermission }) => {
  if (!user) return false;
  if (user.role === "admin") return true;
  const key = item.permissionKey || item.key;
  if (hasPermission(key)) return true;
  return Boolean(hasRole(item.roles) && hasPermission(key));
};

export function filterDomainNavigationByAccess(domains, auth) {
  return domains.map((domain) => ({
    ...domain,
    sections: domain.sections
      .map((section) => ({
        ...section,
        items: section.items.filter((item) => canAccessPage(item, auth)),
      }))
      .filter((section) => section.items.length > 0),
  })).filter((domain) => domain.sections.length > 0);
}

export function flattenDomainPages(domains) {
  return domains.flatMap((domain) =>
    domain.sections.flatMap((section) => section.items)
  );
}

export function groupPagesForCommand(pages) {
  const groups = new Map();
  for (const page of pages) {
    if (!groups.has(page.domain)) groups.set(page.domain, []);
    groups.get(page.domain).push(page);
  }
  return Array.from(groups, ([id, items]) => ({ id, items }));
}
